import Chart from 'chart.js';

// US-4328 (dark mode): os gráficos são canvas (chart.js), então cores de
// eixo/grade/legenda NÃO respondem a CSS — precisam ser setadas via JS. Lemos
// os tokens de tema já resolvidos no :root (claro OU escuro) e aplicamos como
// defaults globais do Chart.js. Como as chartOptions por relatório substituem
// `scales` inteiro (METRIC_CHART), o default global é o ponto mais confiável.
// Chamar no mounted() de cada gráfico, antes de renderChart.
export default function applyChartTheme() {
  const cs = getComputedStyle(document.documentElement);
  const ink = cs.getPropertyValue('--color-ink-soft').trim() || '#8492a6';
  const grid = cs.getPropertyValue('--color-hairline').trim() || '#ebf0f5';

  Chart.defaults.global.defaultFontColor = ink;
  if (Chart.defaults.scale && Chart.defaults.scale.gridLines) {
    Chart.defaults.scale.gridLines.color = grid;
    Chart.defaults.scale.gridLines.zeroLineColor = grid;
  }
}
